import Button from "@mui/material/Button";
import moment from "moment";
import { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { CheckTaskCreated, EndSprintPanel } from ".";
import sporticon from "../../../assets/icon/sport.png";
import Constants from "../../../constant";
import { Campaign } from "@hero/shared/models/campaign";
import { ISprint } from "@hero/shared/models/sprint";
import { IUserGroup } from "@hero/shared/models/userGroup";
import { ICoefficients, IUserInfo } from "@hero/shared/models/userInfo";
import { formatDate, isAdmin, workingDaysBetweenDates } from "../../../util";
import { BasicMenu } from "../../Header";
import CreateCampaignModal from "../campaign/create-campaign-modal";
import CreateSprintModal from "../sprint/create-sprint-modal";
import CreateTaskModal from "../task-preview/create-task-modal";
import FunctionButton from "./FunctionButton";
import UserIndicator from "./UserIndicator";
import "./style.scss";
import { roleForPoint } from "@hero/shared/utils";
import Config from "@hero/shared/models/config";
import IconButton from "@mui/material/IconButton";

const MENU_GROUPS = [
    {
        title: "Tổng quan",
        icon: "📋",
        items: [
            Constants.DASHBOARD,
            Constants.REPORTS,
        ],
    },
    // {
    //     title: "Phát hành",
    //     icon: "🚀",
    //     items: [Constants.RELEASES],
    // },
    // {
    //     title: "Tuyển dụng",
    //     icon: "👥",
    //     items: [Constants.RECRUITMENT, Constants.INFORECRUITMENT],
    // },
    // {
    //     title: "Công cụ",
    //     icon: "🛠️",
    //     items: [Constants.TOOL, Constants.INFORATING],
    // },
];

const DashboardSidebarV2: FC<{
    currentSprint: ISprint;
    backButton: boolean;
    currentUsersInfo: any[];
    userTaskScore: any;
    userDisciplineScore: any;
    coefs: { [userId: string]: ICoefficients };
}> = ({ currentSprint, backButton, currentUsersInfo, userTaskScore, userDisciplineScore, coefs }) => {
    const sprints: ISprint[] = useSelector((state: any) => state.sprintState.sprints ?? []);
    const userInfo: IUserInfo = useSelector((state: any) => state.authState.user);
    const projects = useSelector((state: any) => state.projectState.projects ?? []);
    const pageName = useSelector((state: any) => state.page);
    const userGroups: IUserGroup[] = useSelector((state: any) => state.userGroupState.userGroups ?? []);
    const [showCreateTaskModal, setShowCreateTaskModal] = useState(false);
    const [showCreateCampaignModal, setShowCreateCampaignModal] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const history = useHistory();
    let sprintID: string = currentSprint._id;
    const showAllSprint = (history.location.search?.indexOf("showAllSprint=true") ?? -1) > -1;
    const s = sprints.sort((a, b) => {
        if(a.backLog == true && b.backLog == true) {
            return -1;
        }
        return (b?.endDate?.getTime() ?? 0) - (a?.endDate?.getTime() ?? 0)
    });
    const listSprints = (showAllSprint ? s : s.slice(0, 4)).sort((a, b) => b?.name?.localeCompare(a?.name));
    const [showCreateSprintModal, setShowCreateSprintModal] = useState(false);

    useEffect(() => {
        if (!showMenu) return;
        const handler = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) setShowMenu(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [showMenu]);

    const isUserGroups: IUserGroup[] = userGroups.filter((group) => group.users.some((user) => user.userId === userInfo._id));
    let checkPermission: boolean | undefined;
    isUserGroups.map((data) => {
        data?.users?.forEach((d) => {
            d?.permission?.find((dt) => {
                if (d.permission !== undefined && d.permission.length > 0 && dt === Config.PERMISSION_EDITOR_CAMPAIGN) {
                    checkPermission = true;
                }
            });
        });
    });
    const checkRoleToAddCampaign = () => checkPermission ? true : false;

    return (
        <div className="sidebar-v2">
            {/* Sprint header */}
            <div
                style={{ padding: "16px", justifyContent: "space-between" }}
                className="background-white-008 radius-12 align-item-center"
            >
                <div className="column">
                    <div className="align-item-center">
                        <img src={sporticon} style={{ width: "24px", height: "24px", margin: "1px 4px" }} />
                        <span className="white" style={{ fontSize: "22px", fontWeight: 500, marginLeft: "10px" }}>
                            {currentSprint?.name}
                        </span>
                    </div>
                    <span style={{ color: "#6B7280", fontSize: "12px" }}>
                        {formatDate(new Date(currentSprint?.startDate) ?? new Date(), "dd/mm/yyyy") +
                            " - " +
                            formatDate(new Date(currentSprint?.endDate) ?? new Date(), "dd/mm/yyyy")}
                    </span>
                </div>

                {/* Menu trigger */}
                <div ref={menuRef} style={{ position: "relative" }}>
                    <IconButton
                        onClick={() => setShowMenu(!showMenu)}
                        sx={{
                            width: 36, height: 36,
                            background: showMenu ? "rgba(255,255,255,0.12)" : "transparent",
                            "&:hover": { background: "rgba(255,255,255,0.1)" },
                        }}
                    >
                        <span style={{ color: "#fff", fontSize: 18 }}>☰</span>
                    </IconButton>

                    {/* Dropdown menu */}
                    {showMenu && (
                        <div style={{
                            position: "absolute",
                            top: 44,
                            right: 0,
                            width: 240,
                            background: "#1e1e3c",
                            borderRadius: 12,
                            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
                            overflow: "hidden",
                            zIndex: 100,
                            animation: "menuSlideIn 0.12s ease-out",
                        }}>
                            {!backButton && MENU_GROUPS.map((group) => (
                                <div key={group.title}>
                                    <div style={{
                                        padding: "8px 14px 4px",
                                        fontSize: 11,
                                        fontWeight: 600,
                                        color: "rgba(255,255,255,0.4)",
                                        textTransform: "uppercase",
                                        letterSpacing: 0.5,
                                    }}>
                                        {group.icon} {group.title}
                                    </div>
                                    {group.items.map((item) => (
                                        <div
                                            key={item.pageName}
                                            onClick={() => { setShowMenu(false); }}
                                            style={{ paddingLeft: 32, fontSize: 13 }}
                                        >
                                            <FunctionButton pageData={item} active={pageName === item} />
                                        </div>
                                    ))}
                                </div>
                            ))}

                            {/* Sprint list */}
                            <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", marginTop: 4 }}>
                                <div style={{
                                    padding: "8px 14px 4px",
                                    fontSize: 11,
                                    fontWeight: 600,
                                    color: "rgba(255,255,255,0.4)",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                }}>
                                    🏃 Sprints
                                </div>
                                <div style={{ maxHeight: 200, overflow: "auto" }}>
                                    {listSprints.map((sprint: ISprint) => {
                                        const active = sprint._id == sprintID;
                                        return (
                                            <a
                                                href={"/sprint/" + (sprint.shortId ? sprint.shortId : sprint._id)}
                                                key={sprint._id}
                                                onClick={() => setShowMenu(false)}
                                                style={{
                                                    display: "block",
                                                    padding: "6px 14px",
                                                    fontSize: 13,
                                                    color: active ? "#4da1ff" : "rgba(255,255,255,0.75)",
                                                    textDecoration: "none",
                                                    transition: "background 0.1s",
                                                    background: active ? "rgba(77,161,255,0.1)" : "transparent",
                                                }}
                                                onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                                                onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
                                            >
                                                {sprint.name}
                                                {sprint.activeSprint && <span style={{ color: "#4ade80", marginLeft: 4, fontSize: 11 }}>(active)</span>}
                                                {!sprint.backLog && (
                                                    <div style={{ fontSize: 11, color: "#6B7280", margin: 0 }}>
                                                        {workingDaysBetweenDates(sprint.startDate, sprint.endDate)} ngày (
                                                        {moment(sprint.startDate).format("MMM D")} - {moment(sprint.endDate).format("MMM D")})
                                                    </div>
                                                )}
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Action buttons */}
            <div style={{ padding: "12px 12px 0" }}>
                <CheckTaskCreated onCreatedTask={() => setShowCreateTaskModal(false)} />
                <Button
                    variant="contained"
                    onClick={() => setShowCreateTaskModal(true)}
                    className="btn-open-create-task-modal radius-12"
                >
                    Thêm Task
                </Button>
                {showCreateTaskModal && (
                    <CreateTaskModal onHide={() => setShowCreateTaskModal(false)} currentSprintID={sprintID} user={userInfo} />
                )}
                <div className="add-new-task-btn-container">
                    {!sprintID && (
                        <Button variant="contained" style={{ width: "100%", marginTop: "10px" }} onClick={() => history.goBack()}>
                            Back
                        </Button>
                    )}
                    {!backButton && isAdmin(userInfo) && (
                        <Button
                            variant="contained"
                            onClick={() => setShowCreateSprintModal(true)}
                            className="btn-open-create-task-modal radius-12"
                        >
                            Thêm Sprint
                        </Button>
                    )}
                    {showCreateSprintModal && <CreateSprintModal onHide={() => setShowCreateSprintModal(false)} />}
                    {!backButton && checkRoleToAddCampaign() && (
                        <Button
                            variant="contained"
                            onClick={() => setShowCreateCampaignModal(true)}
                            className="btn-open-create-task-modal radius-12"
                        >
                            Thêm Campaign
                        </Button>
                    )}
                    {showCreateCampaignModal && (
                        <CreateCampaignModal
                            onHide={() => setShowCreateCampaignModal(false)}
                            currentSprintId={sprintID}
                            campaign={new Campaign({})}
                        />
                    )}
                    {isAdmin(userInfo) && <div>{currentSprint?.activeSprint && <EndSprintPanel />}</div>}
                </div>
            </div>

            {/* User info */}
            <div className="user-info">
                <div className="flex padding-12" style={{ justifyContent: "space-between" }}>
                    <div className="avatar flex align-item-center">
                        <div className="avatar-image align-item-center justify-content-center">
                            <BasicMenu userInfo={userInfo} />
                        </div>
                        <div className="column" style={{ marginLeft: "10px", justifyContent: "space-between" }}>
                            <div className="white" style={{ fontSize: "18px", fontWeight: 500, lineHeight: "24px" }}>
                                {userInfo.firstName}
                            </div>
                            <div style={{ fontSize: "12px", color: "#CED8E1", lineHeight: "14px" }}>
                                {userInfo.position}
                            </div>
                            {roleForPoint(userInfo) && (
                                <div style={{ fontSize: "12px", color: "#CED8E1", lineHeight: "14px" }}>
                                    Level: {userInfo.level}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {roleForPoint(userInfo) && userInfo.role !== Config.USER_ROLE_ADMIN && userInfo.role !== Config.USER_ROLE_LEADER && userInfo.role !== Config.USER_ROLE_MID_LEADER && (
                    <UserIndicator
                        user={userInfo}
                        sprint={currentSprint}
                        disciplinePoints={userDisciplineScore[userInfo._id]}
                        taskScores={userTaskScore[userInfo._id]}
                        isUserAuthStaff={true}
                        coefs={coefs[userInfo._id]}
                    />
                )}
                {currentUsersInfo.map((user) => (
                    <UserIndicator
                        user={user}
                        sprint={currentSprint}
                        disciplinePoints={userDisciplineScore[user._id]}
                        taskScores={userTaskScore[user._id]}
                        key={user._id}
                        coefs={coefs[user._id]}
                    />
                ))}
            </div>

            <style>{`
                @keyframes menuSlideIn {
                    from { opacity: 0; transform: translateY(-6px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default DashboardSidebarV2;
